// Dedicated alphanumeric access key for the evacuation-training common provider.
const HINAN_KUNREN_COMMON_ACCESS_KEY = "a7Kp3Xn9Qw2Lm6Rt";
const HINAN_KUNREN_SEASON_1_ID = "cmt8v3v940001a4zc1b2v7nvx";
const HINAN_KUNREN_SEASON_2_ID = "cmunx0pg90000mnzc5f0yg7iv";
const HINAN_KUNREN_SEASON_3_ID = "cmvwcgsza000008nyfbk364fl";

export {
  HINAN_KUNREN_COMMON_ACCESS_KEY,
  HINAN_KUNREN_SEASON_1_ID,
  HINAN_KUNREN_SEASON_2_ID,
  HINAN_KUNREN_SEASON_3_ID,
};
